import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translation } from '../../../../../../utils/helpers'

import DropDown from '../../../../../../shared/elements/dropDown'

// Styles
import '../inputcomponents.scss'

class InputSelectList extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.translate = this.translate.bind(this)
    this.mapItems = this.mapItems.bind(this)
  }
  onInputChange (e) {
    // console.log('[InputSelectList] change', e.target.name, e.target.value)
    this.props.onChange(e)
  }
  componentDidMount () {
  }
  translate (text) {
    if (!this.props.translate || isNaN(Number(text))) return text
    return translation(text)
  }
  mapItems (val, index) {
    let value = val[this.props.listItemValName[0]]
    let showVal = this.translate(val[this.props.listItemValName[1]])
    return <option value={value} key={index}>{showVal}</option>
  }
  render () {
    let mapItems = this.props.mapItems ? this.props.mapItems : this.mapItems

    return (
      <DropDown
        name={this.props.name}
        value={this.props.value}
        onChange={this.onInputChange}
        disabled={this.props.disabled}
        labelText={this.props.showTitle && translation(this.props.title)}
      >
        {this.props.listItems.map(mapItems)}
      </DropDown>
    )
  }
}

InputSelectList.defaultProps = {
  disabled: false,
  onChange: (e) => {
    console.log('todo')
  },
  name: 'None',
  value: '',
  title: '*title*',
  listItems: [],
  showTitle: true,
  listItemValName: ['', ''],
  translate: false
}

InputSelectList.propTypes = {
  mapItems: PropTypes.func,
  translate: PropTypes.bool,
  showTitle: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  listItems: PropTypes.array.isRequired,
  auth: PropTypes.object.isRequired
}

InputSelectList.contextTypes = {
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(InputSelectList)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/InputComponents/InputSelectList/index.js